import { getBeneficiariesURL } from '../../../helpers/api-urls.js';

/**
 * Fetch an investor's existing beneficiary designation, if any. Shared by
 * BeneficiariesWizard.vue (to prefill the form) and the dashboard's always-available
 * action card (to decide "Add Now" vs "Manage" and its description).
 *
 * getBeneficiariesURL is documented as not yet implemented server-side, so a 404/network
 * error here just means "no existing designation" -- not a failure callers need to
 * surface. Returns null in that case rather than throwing.
 *
 * @param {{ client: string, userid: string, cookie: string, userName?: string }} params
 * @returns {Promise<{ primary: Array<object>, contingent: Array<object> } | null>}
 */
export async function fetchExistingBeneficiaries({ client, userid, cookie, userName }) {
	if (!window.axios) return null;
	try {
		const res = await window.axios.get(getBeneficiariesURL, {
			params: { client, userid, cookie, userName },
		});
		return res.data ?? null;
	} catch {
		return null;
	}
}
